import $ from 'jquery';
import { getFullUrlPath } from './common';
let label;
$.ajax(getFullUrlPath('NewIndex/GetLabel'), {
    async: false,
    success: data => {
        // label = new Proxy(data, {
        //     get(target, name) {
        //         if(!target[name]) {
        //             console.warn(`Label.${name} does not exist`);
        //         }

        //         return target[name];
        //     }
        // });
        label = data;
    },
    error: console.error
});

export default label;